export default __webpack_public_path__ + "5033c8497718f1a67845232d06de0bf8.woff";